//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['slug', 'imageUrl', 'imageAlt', 'title', 'description', 'createdAt'],
};
